import { render, staticRenderFns } from "./MsgList.vue?vue&type=template&id=a6fc4c76&scoped=true"
import script from "./MsgList.vue?vue&type=script&lang=js"
export * from "./MsgList.vue?vue&type=script&lang=js"
import style0 from "./MsgList.vue?vue&type=style&index=0&id=a6fc4c76&prod&scoped=true&lang=less"
import style1 from "./MsgList.vue?vue&type=style&index=1&id=a6fc4c76&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fc4c76",
  null
  
)

export default component.exports